export const EEditProfileWorkFieldArrayName = 'job_experiences';
export const otherInformationFieldArray = 'achievements';
export enum EEditProfileFieldArrayNames {
  EDUCATION = 'educations',
  DEGREE = 'academic_degree',
  PROFESSIONAL_RETRAINING = 'professional_retrainings',
  ADVANCED_TRAINING = 'trainings',
  CERTIFICATES = 'certificates',
}
